.field {
  display: grid;
  gap: 6px;
  margin-bottom: 4px;
}

.details {
  display: grid;
  gap: 6px;
  margin: 0;
  padding: 10px 12px;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: var(--bg-raised);
  font-size: 14px;
}

.details div {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.details dt {
  color: var(--muted);
}

.details dd {
  margin: 0;
}
